import url from "url";

export const getPath = (urlWithPath: string) => {
  const parsedUrl = url.parse(urlWithPath);
  return parsedUrl.path;
}
